import Icons from "./icons";

/**
 * Status metadata shared by test cases and individual steps.
 * Keys: passed | failed | running | pending
 */
export const STATUS = {
  passed: {
    label: "Passed",
    icon: Icons.Check,
    badge: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
    dot: "bg-emerald-500",
    ring: "ring-emerald-500/30",
    text: "text-emerald-600",
    solid: "bg-emerald-500 text-white",
  },
  failed: {
    label: "Failed",
    icon: Icons.X,
    badge: "bg-rose-50 text-rose-700 ring-rose-600/20",
    dot: "bg-rose-500",
    ring: "ring-rose-500/30",
    text: "text-rose-600",
    solid: "bg-rose-500 text-white",
  },
  running: {
    label: "Running",
    icon: Icons.Spinner,
    badge: "bg-amber-50 text-amber-700 ring-amber-600/20",
    dot: "bg-amber-400",
    ring: "ring-amber-500/30",
    text: "text-amber-600",
    solid: "bg-amber-500 text-white",
  },
  pending: {
    label: "Not run",
    icon: Icons.Clock,
    badge: "bg-slate-100 text-slate-600 ring-slate-500/20",
    dot: "bg-slate-300",
    ring: "ring-slate-400/30",
    text: "text-slate-500",
    solid: "bg-slate-400 text-white",
  },
  cancelled: {
    label: "Stopped",
    icon: Icons.X,
    badge: "bg-slate-100 text-slate-600 ring-slate-500/20",
    dot: "bg-slate-400",
    ring: "ring-slate-400/30",
    text: "text-slate-500",
    solid: "bg-slate-500 text-white",
  },
};

export const statusOf = (key) => STATUS[key] || STATUS.pending;
